module.exports = __webpack_public_path__ + "static/img/about_img1.c50647c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about_img1.png
// module id = kU5h
// module chunks = 0